import LRU from 'lru-cache'

const cache = new LRU({
  maxAge: 30 * 60 * 1000, // maxAge is in ms ~30mins
  max: 500000000000,
  length: (n) => {
    return n.length * 100 // n = item passed in to be saved (value)
  },
})

const chunker = (list: any[], base?: any[]): any[][] => {
  let cutoff: number = 100
  if (!base) { base = [] }

  if (list.length > cutoff) {
    let nextList: any[] = Array.from(list).slice(cutoff)
    base.push(list.slice(0, cutoff))
    return chunker(nextList, base)
  }
  else {
    base.push(list)
  }
  return base
}

export const set = (key: string, value: any): any => cache.set(key, value)
export const get = (key: string): any => cache.get(key)
export const del = (key: string): any => cache.del(key) // clear key from cache
export const reset = (): any => cache.reset() // clears entire cache

export default {
  get,
  set,
  del,
  reset
}
